import { render } from "./createConfigSimulatorComponent.vue?vue&type=template&id=28cfa0dc&scoped=true"
import script from "./createConfigSimulatorComponent.vue?vue&type=script&lang=js"
export * from "./createConfigSimulatorComponent.vue?vue&type=script&lang=js"

import "./createConfigSimulatorComponent.vue?vue&type=style&index=0&id=28cfa0dc&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28cfa0dc"]])

export default __exports__